import React from 'react';
import { Text, i18n, tokens } from '@simplybenefits/sb-ui-library';
import { numberWithCommas } from '../../services/helpers.js';
import Accordion from '@mui/material/Accordion';
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';
import { Add as AddIcon, Remove as RemoveIcon } from '@mui/icons-material';

/**
 *
 * @param {*} props
 */
export default function DependentLife({ classes, expanded, dependentLife, handleChange }) {
    return (
        <div style={ classes.block }>
            <Accordion
                square
                onChange={handleChange('dependentLife')}
                style={{ boxShadow: 'none' }}
                disableGutters={true}
            >
                <AccordionSummary
                    classes={{
                        content: classes.panelContent,
                        expanded: classes.expanded,
                        root: classes.root
                    }}
                    expandIcon={expanded.includes('dependentLife') ? <RemoveIcon /> : <AddIcon />}
                    sx={classes.accordionSummary}
                >
                    <Text medium bold>{ i18n.t(tokens.titles.dependentLife) }</Text>
                </AccordionSummary>
                <AccordionDetails style={classes.panelDetails}>
                    {
                        dependentLife.isEligible !== 1 ? 
                            <div style={classes.row}>
                                <Text small bold margin="20px 0px 10px 0px">
                                    { i18n.t(tokens.labels.coverage.ineligibleForBenefit)}
                                </Text>
                            </div>
                            : 
                            null
                    }
                    
                    <Text small bold margin="10px 0px 10px 0px">
                        { i18n.t(tokens.labels.coverage.dependentLifeEligibility, { eligibilityPeriod: dependentLife.eligibilityPeriod, minHoursPerWeek: dependentLife.minHoursPerWeek })}
                    </Text>

                    {
                        dependentLife.spouseCoverage ?
                            <Text small bold margin="20px 0px 10px 0px">
                            { i18n.t(tokens.labels.coverage.spouseCoverage, { spouseCoverage: numberWithCommas(dependentLife.spouseCoverage) }) }
                            </Text>
                            : 
                            null
                    }

                    {
                        dependentLife.childCoverage ?
                            <Text small bold margin="0px 0px 10px 0px">
                                { i18n.t(tokens.labels.coverage.childCoverage, { childCoverage: numberWithCommas(dependentLife.childCoverage) }) }
                            </Text>
                            : 
                            null
                    }

                    <Text small margin="5px 0px 0px 0px">{ i18n.t(tokens.labels.coverage.terminatesAtAge, { terminationAge: dependentLife.terminationAge }) }</Text>
                    
                </AccordionDetails>
            </Accordion>
        </div>
    )
}